import { create } from 'zustand';

const useTraitShuffleStore = create((set) => ({
  activeTab: 0,
  selectedNft: null,
  selectedTrait: null,
  failedTraitImages: [],
  initiateShuffleSuccess: false,
  initiateShuffleUpdates: null,
  previewTrait: null,
  previewTraitWithDependencies: null,
  showSuccessModal: false,
  newKittyMetadata: null,

  dismissedFlaggedTraits: false,

  shuffleHistory: [],

  setActiveTab: (tab) => {
    set({ activeTab: tab, initiateShuffleSuccess: false, initiateShuffleUpdates: null });
  },
  selectNft: (nft) =>
    set({
      selectedNft: nft,
      failedTraitImages: [],
      selectedTrait: null,
      initiateShuffleSuccess: false,
      initiateShuffleUpdates: null,
      dismissedFlaggedTraits: false,
      previewTrait: null,
      previewTraitWithDependencies: null,
      showSuccessModal: false,
      newKittyMetadata: null,
    }),

  updateMetadata: (metadata) =>
    set((state) => {
      const updatedNft = state.selectedNft ? { ...state.selectedNft, metadata } : state.selectedNft;
      return { selectedNft: updatedNft };
    }),

  selectTrait: (trait) => set({ selectedTrait: trait, previewTrait: null, previewTraitWithDependencies: null }),

  addFailedTraitImage: (image) =>
    set((state) => {
      const updatedFailedTraitImages = [...state.failedTraitImages, image];
      return { failedTraitImages: updatedFailedTraitImages, initiateShuffleSuccess: false, initiateShuffleUpdates: null };
    }),

  setInitiateShuffleSuccess: (success) => set({ initiateShuffleSuccess: success }),
  setInitiateShuffleUpdates: (updates) => set({ initiateShuffleUpdates: updates }),

  setPreviewTrait: (trait) => set({ previewTrait: trait }),
  clearPreviewTrait: () => set({ previewTrait: null, previewTraitWithDependencies: null }),

  setPreviewTraitWithDependencies: (traitWithDependencies) => set({ previewTraitWithDependencies: traitWithDependencies }),

  setDismissedFlaggedTraits: (dismissed) => set({ dismissedFlaggedTraits: dismissed }),

  setShowSuccessModal: (show) => set({ showSuccessModal: show }),
  setNewKittyMetadata: (metadata) => set({ newKittyMetadata: metadata }),

  addShuffleToHistory: (shuffle) =>
    set((state) => ({
      shuffleHistory: [shuffle, ...state.shuffleHistory].slice(0, 50),
    })),

  reset: () =>
    set({
      activeTab: 0,
      selectedNft: null,
      failedTraitImages: [],
      initiateShuffleSuccess: false,
      initiateShuffleUpdates: null,
      dismissedFlaggedTraits: false,
      previewTrait: null,
      previewTraitWithDependencies: null,
      showSuccessModal: false,
      newKittyMetadata: null,
    }),
}));

export default useTraitShuffleStore;
